export default "__VITE_ASSET__33da6623__"